import script from "./SchoolAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolAbout.vue?vue&type=script&setup=true&lang=js"

import "./SchoolAbout.vue?vue&type=style&index=0&id=52145735&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52145735"]])

export default __exports__